import React from 'react';
import classNames from 'classnames';
import clsx from 'clsx';
import { FunwooLineQRCode } from '@/src/components/UI/HouseDetail/ModalPopup';
import { ConsultantFormPopup } from '@/src/components/feature/ConsultantForm/GreetingPopup';
import { useDisclosure } from '@chakra-ui/react';

const HintWording = () => {
  const { isOpen: isQRCodeOpen, onClose: onQRCodeClose, onOpen: onQRCodeOpen } = useDisclosure();

  return (
    <React.Fragment>
      <ConsultantFormPopup
        isOpen={isQRCodeOpen}
        onClose={onQRCodeClose}
        title={<p className={clsx('pl-6', 'text-lg', 'font-medium')}>掃描 QR Code 加入官方帳號</p>}
      >
        <div className={clsx('space-y-8')}>
          <div className={clsx('p-0.5', 'border border-gray300')}>
            <div className={clsx('p-0.5')}>
              <FunwooLineQRCode lineQR={'https://line.me/ti/p/@funwoo'} className={clsx('w-45 h-45')} size={180} />
            </div>
          </div>
          <p className={clsx('py-2', 'text-center', 'whitespace-pre-wrap', 'text-gray700', 'sm:hidden sm:invisible')}>
            加入 FUNWOO 官方 LINE
            <br />
            立即諮詢美國房產
          </p>
        </div>
      </ConsultantFormPopup>
      <p className={classNames('mb-2', 'py-2', 'sm:text-center', 'whitespace-pre-wrap')}>
        我們將於 24 小時內與您聯繫，也歡迎撥打專線{' '}
        <a href={`tel:${process.env.NEXT_PUBLIC_FUNWOO_TAIWAN_CELLPHONE}`} className={clsx('underline')}>
          {process.env.NEXT_PUBLIC_FUNWOO_TAIWAN_CELLPHONE}
        </a>
        ，或加入官方 LINE{' '}
        <button type={'button'} className={clsx('underline')} onClick={onQRCodeOpen}>
          @funwoo
        </button>{' '}
        洽詢。
      </p>
    </React.Fragment>
  );
};

export default HintWording;
